// cSpell:ignore Volgende Vorige
// The settlement wizard's footer, as the dashboard's other wizards set theirs
// (MultiStepForm in web-shared, e.g. creating a contract or a payment order):
// the buttons on one row on the left, "Vorige" first in the default
// appearance and the step's own action after it in the primary one, the
// row `spacing("loose")` under the step (MultiStepForm's Actions).
//
// Why a step cannot go on is said ABOVE that row, never between its
// buttons (Lewis, 2026-10-17): a sentence there pushed "Vorige" and
// "Volgende" apart.

import { Banner } from "@rentiohq/web-shared/dist/components";
import { ButtonGroup } from "@rentiohq/web-shared/dist/components/ButtonGroup";
import styled, { spacing } from "@rentiohq/web-theme";
import React from "react";

const Footer = styled.div`
  margin-top: ${spacing("loose")};
`;

// The banners keep their own space between them.
const Messages = styled.div`
  margin-bottom: ${spacing("base")};
`;

export const WizardFooter: React.FC<{
  // Why the step's action is disabled, each in a warning of its own.
  messages?: (string | undefined | false)[];
  children: React.ReactNode;
}> = ({ messages = [], children }) => {
  const shown = messages.filter(
    (message): message is string => !!message && message.trim() !== "",
  );
  return (
    <Footer>
      {shown.length > 0 && (
        <Messages role="status">
          {shown.map(message => (
            <Banner key={message} variation="warning" hasDismiss={false}>
              {message}
            </Banner>
          ))}
        </Messages>
      )}
      <ButtonGroup align="left">{children}</ButtonGroup>
    </Footer>
  );
};
